import api from "./configuration";
import apiUrl from "./url";

export const ScoutingPipelineAPI = {
	list: async (seasonId) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + "/ScoutingPipeline",
				useAuthInterceptor: true,
				params: {seasonId},
			})
		).data,
	put: async (playerId, data) =>
		(
			await api.request({
				method: "PUT",
				url: apiUrl + "/ScoutingPipeline/" + playerId,
				useAuthInterceptor: true,
				data,
			})
		).data,
	remove: async (playerId) =>
		(
			await api.request({
				method: "DELETE",
				url: apiUrl + "/ScoutingPipeline/" + playerId,
				useAuthInterceptor: true,
			})
		).data,
};
